export const contact = {
  bannerTextBig: 'KONTAKT',
  bannerTextBigMobile: 'KONTAKT',
  postalAddress: 'Postanschrift',
  hausHeld: 'HausHeld.ch',
  vermando: 'c/o Vermando AG',
  address: 'Bahnhofstrasse 4',
  city: 'CH-9100 Herisau',
  phoneOwner: 'Telefon für Eigentümer',
  phoneNumberOwner: '+41 (0)71 508 72 04',
  emailOwner: 'kontakt@hausheld.ch',
  phonePartner: 'Telefon für Partner',
  phoneNumberPartner: '+41 (0)71 508 72 05',
  emailPartner: 'partner@hausheld.ch',
  openingHours: 'Öffnungszeiten',
  times: 'Mo-Fr 9-17 Uhr',
  questions: 'Haben Sie eine Frage oder möchten uns etwas mitteilen?',
  questionsText:
    'Wir sind immer offen für Ihre Anliegen. Stellen Sie Ihre Frage einfach per Formular. Wir werden uns schnellstmöglich bei Ihnen melden. Sie haben einen Fehler gefunden, einen Verbesserungsvorschlag oder ein technisches Problem? Wir sind dankbar, wenn Sie uns dies mitteilen.',
  emailFieldText: 'E-Mail',
  phoneFieldText: 'Mobil/Telefon',
  referenceFieldText: 'Betreff',
  messageFieldText: 'Nachricht',
  sendButtonText: 'Senden',
  startNow: 'Jetzt Starten',
  successText: 'Ihre Anfrage wurde erfolgreich übermittelt.',
}
